import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { AppRoute } from "@/App";
import { CONFIG } from "@/config";

export const useNavigation = () => {
  const navigate = useNavigate();

  const navigateToChat = useCallback(() => navigate(AppRoute.Chat), [navigate]);
  const navigateToCardOfTheDay = useCallback(() => navigate(AppRoute.CardOfTheDay), [navigate]);
  const navigateToAstroPrognosis = useCallback(() => navigate(AppRoute.AstroPrognosis), [navigate]);
  const navigateToZodiacPrognosis = useCallback(() => navigate(AppRoute.ZodiacPrognosis), [navigate]);
  const navigateToLuckyCard = useCallback(() => navigate(AppRoute.LuckyCard), [navigate]);
  const navigateToSubscription = useCallback(() => navigate(AppRoute.Subscription), [navigate]);
  
  const navigateToAstrologChanel = useCallback(() => {
    window.open(CONFIG.links.telegramAstrolog, "_blank");
  }, []);
  
  const navigateToDeveloperChanel = useCallback(() => {
    window.open(CONFIG.links.telegramDeveloper, "_blank");
  }, []);

  return {
    navigateToChat,
    navigateToCardOfTheDay,
    navigateToAstroPrognosis,
    navigateToZodiacPrognosis,
    navigateToLuckyCard,
    navigateToAstrologChanel,
    navigateToDeveloperChanel,
    navigateToSubscription,
  };
}; 